import footerDataAr from "../data/arabic/footer-data-ar"
import footerDataEn from "../data/english/footer-data";
import ArrowRightRed from '../assets/icons/arrow-right-red.svg';
import InstagramIcon from '../assets/icons/instagram-icon.svg';
import FacebookIcon from '../assets/icons/facebook-icon.svg';
import TwitterIcon from '../assets/icons/twitter-icon.svg';
import LinkedinIcon from '../assets/icons/linkedin.svg';
import ReactVisibilitySensor from "react-visibility-sensor";
import { useContext } from "react";
import PageContextType from "../types/PageContextType";
import { InsightContext, LangContext, NewsContext, PageContext } from "../App";
import newsPageDataEn from "../data/english/subpages/news-page-data";
import insightPageDataEn from "../data/english/subpages/insight-page-data";
import newsPageDataAr from "../data/arabic/subpages/news-page-data-ar";
import insightPageDataAr from "../data/arabic/subpages/insight-page-data-ar";

const icons : string[] = [
    TwitterIcon,
    FacebookIcon,
    InstagramIcon,
    LinkedinIcon
]

const Footer = ({ withBlogs = false } : { withBlogs : boolean }) => {
    const { lang } = useContext(LangContext)

    const { handleChangePage, currentPage } = useContext<PageContextType>(PageContext);
    const { handleChangeCurrentInsightData } = useContext(InsightContext);
    const { handleChangeCurrentNewsData } = useContext(NewsContext);

    const newsPageData = lang === 0 ? newsPageDataEn : newsPageDataAr;
    const insightPageData = lang === 0 ? insightPageDataEn : insightPageDataAr;
    const footerData = lang === 0 ? footerDataEn : footerDataAr;

  return (
    <footer id="footer" className="footer">
        {withBlogs ?
        <div className="footer-section-one">
            <div className="wrapper-small">
                <div className="footer-flex-container">
                    <div className="footer-row">
                        <div className="row-header">
                            <h3 className="title">{lang ? "الأخبار" : "News"}</h3>
                        </div>
                        <div className="row-content">
                            {newsPageData.sections[0].articles.map((item, index) => (
                                <div key={index} className="footer-col">
                                    <img 
                                        src={require(`../assets/images/news/${item.image.name}`)} 
                                        alt={item.image.alt} 
                                        className={`paragraph-image`}
                                    />
                                        <div className={`blog`}>
                                            <p>{item.title}</p>
                                            <button
                                                type="button"
                                                className="footer-link"
                                                title={`Read more about ${item.title}`}
                                                onClick={() => {
                                                    handleChangeCurrentNewsData(0, index)
                                                }}
                                            >
                                                <span>{!lang ? "Read More" : "أقرأ المزيد"}</span>
                                                <img src={ArrowRightRed} className={lang === 0 ? "" : "rotate-rtl"} alt={""} aria-hidden="true" />
                                            </button>
                                        </div>
                                </div>
                            ))}
                            <div className="footer-col">
                                    <img 
                                        src={require(`../assets/images/news/${newsPageData.sections[1].articles[0].image.name}`)} 
                                        alt={newsPageData.sections[1].articles[0].image.alt} 
                                        className={`paragraph-image`} 
                                    />
                                        <div className={`blog`}>
                                            <p>{newsPageData.sections[1].articles[0].title}</p>
                                            <button
                                                type="button"
                                                className="footer-link"
                                                title={`Read more about ${newsPageData.sections[1].articles[0].title}`}
                                                onClick={() => {
                                                    handleChangeCurrentNewsData(1, 0)
                                                }}
                                            >
                                                <span>{!lang ? "Read More" : "أقرأ المزيد"}</span>
                                                <img src={ArrowRightRed} className={lang === 0 ? "" : "rotate-rtl"} alt={""} aria-hidden="true" />
                                            </button>
                                        </div>
                                </div>
                        </div>
                    </div>
                    <div className="footer-row">
                        <div className="row-header">
                            <h3 className="title">{lang ? "الرؤى" : "Insight"}</h3>
                        </div>
                        <div className="row-content">
                            {insightPageData.articles.map((item, index) => {
                                if (index < 2) {
                                    return (
                                        <div key={index} className="footer-col">
                                            <img 
                                                src={require(`../assets/images/insights/${item.image.name}`)} 
                                                alt={item.image.alt} 
                                                className={`paragraph-image`} 
                                            />
                                                <div className={`blog`}>
                                                    <p>{item.title}</p>
                                                    <button 
                                                        className="footer-link"
                                                        title={`Read more about ${item.title}`}
                                                        onClick={() => {
                                                            handleChangeCurrentInsightData(index)
                                                        }}
                                                    >{!lang ? "Read More" : "أقرأ المزيد"}<img src={ArrowRightRed} className={lang === 0 ? "" : "rotate-rtl"} alt={""} aria-hidden="true" /></button>
                                                </div>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div> :
        ""
        }
        <div className="footer-section-two">
            <div className="wrapper-small">
                <div className="footer-flex-container-two">
                    <div className="footer-col-2">
                        <ul className="footer-list">
                            {footerData.sectionTwo.listOne.map((item, index) => (
                                <li key={index}>
                                    <button 
                                        type="button"
                                        className={`list-link ${lang === 0 ? "" : "rtl"} ${item.path.pageId === currentPage.pageId ? "active" : ""}`}
                                        title={item.discription}
                                        aria-label={item.discription}
                                        onClick={() => handleChangePage(item.path)}
                                    >{item.text}</button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="footer-col-2">
                        <ul className="footer-list">
                            {footerData.sectionTwo.listTow.map((item, index) => (
                                <li key={index}>
                                    <button 
                                        className={`list-link ${lang === 0 ? "" : "rtl"} ${item.path.pageId === currentPage.pageId ? "active" : ""}`}
                                        title={item.discription}
                                        aria-label={item.discription}
                                        onClick={() => handleChangePage(item.path)}
                                    >{item.text}</button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="footer-col-2">
                        <ul className="footer-list">
                            {footerData.sectionTwo.listThree.map((item, index) => (
                                <li key={index} >
                                    <button 
                                        className={`list-link ${lang === 0 ? "" : "rtl"} ${item.path.pageId === currentPage.pageId ? "active" : ""}`}
                                        title={item.discription}
                                        aria-label={`Read more about ${item.discription}`}
                                        onClick={() => handleChangePage(item.path)}
                                    >{item.text}</button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {/* <div className="footer-col-2">
                        <ul className="footer-list">
                            {footerData.sectionTwo.listFour.map((item, index) => (
                                <li key={index}>
                                    <button
                                        className={`list-link ${lang === 0 ? "" : "rtl"} ${item.path.pageId === currentPage.pageId ? "active" : ""}`}
                                        title={item.discription}
                                        onClick={() => handleChangePage(item.path)}
                                    >{item.text}</button>
                                </li>
                            ))}
                        </ul>
                    </div> */}
                    <div className="footer-col-2">
                        <div role="list" className="footer-button-group">
                            {footerData.sectionTwo.listFive.map((item, index) => (
                                <a
                                    role="listitem"
                                    key={index} 
                                    href={item.path}
                                    className="icon"
                                    title={item.image.description}
                                    aria-label={item.image.description}
                                    target="_blank"
                                >
                                    <img src={icons[index]} alt={item.image.alt} />
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer